import axios from 'axios';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import validate from 'validate.js';
import { toast } from 'react-toastify'
import storage from 'services/storage';
import constants from 'constants';
import actions from 'actions';
import { loginStory } from './stories/login.js';
import { push } from 'redux-router';

const {
  addErrorsSaga
} = actions;

const {
  LOGIN_SAGA,
  LOGOUT_SAGA,
  PERFORM_LOGOUT,
  ERROR_TYPE_LOGIN_ERROR,
} = constants;

const successNotification = ({
  first_name, last_name
}) => {
  toast.success(
    `Welcome, ${validate.capitalize(validate.prettify(first_name))} ${validate.capitalize(validate.prettify(last_name))}`
  )
}
function* login({ email, password }) {
    try {
      const response = yield call(loginStory, email, password)
      const user = response.data.user;
      yield call(successNotification, user);

      if (storage.getJoinWebinarId()) {
        const s = storage;
        yield put(push(`/join_webinar/${storage.getJoinWebinarId()}`))
      }

    } catch (e) {
      yield put(addErrorsSaga(ERROR_TYPE_LOGIN_ERROR, e.response))
    }
}

function* logout() {
  try {
    yield call(storage.purgeSessionData);
    yield put({
      type: PERFORM_LOGOUT
    })
  } catch (e) {
    console.log(e);
  }
}

function* loginSaga() {
  yield takeLatest(LOGIN_SAGA, login);
}

function* logoutSaga() {
  yield takeLatest(LOGOUT_SAGA, logout)
}

export { loginSaga, logoutSaga };



/** WEBPACK FOOTER **
 ** ./src/sagas/auth.js
 **/